import { render, staticRenderFns } from "./MainToolbar.vue?vue&type=template&id=dedd7b5c&scoped=true&"
import script from "./MainToolbar.vue?vue&type=script&lang=js&"
export * from "./MainToolbar.vue?vue&type=script&lang=js&"
import style0 from "./MainToolbar.vue?vue&type=style&index=0&id=dedd7b5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dedd7b5c",
  null
  
)

export default component.exports